import type { TFunction } from 'i18next';
import { currentFormatLocale } from '@/lib/i18n';

/** Localized label for enum-ish values with a graceful fallback to the raw value. */
export function enumLabel(
  t: TFunction,
  namespace: string,
  value: string | null | undefined,
): string {
  if (!value) return '';
  const key = `${namespace}.${value}`;
  const translated = t(key);
  return translated === key ? value.replace(/_/g, ' ') : translated;
}

export function groceryCategoryLabel(t: TFunction, value: string) {
  return enumLabel(t, 'enums.groceryCategory', value);
}
export function dietaryLabel(t: TFunction, value: string) {
  return enumLabel(t, 'enums.dietary', value);
}
export function allergenLabel(t: TFunction, value: string) {
  return enumLabel(t, 'enums.allergen', value);
}
export function mealSlotLabel(t: TFunction, value: string) {
  return enumLabel(t, 'enums.mealSlot', value);
}
export function householdRoleLabel(t: TFunction, value: string) {
  return enumLabel(t, 'enums.householdRole', value);
}

export function formatDate(iso: string | null | undefined, locale: string, withTime = false) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  // Callers pass the UI language; the region comes from the browser where it fits (de → de-AT).
  return new Intl.DateTimeFormat(/^[a-z]{2}$/i.test(locale) ? currentFormatLocale() : locale, {
    dateStyle: 'medium',
    ...(withTime ? { timeStyle: 'short' } : {}),
  }).format(d);
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i += 1;
  }
  return `${value.toFixed(value < 10 ? 1 : 0)} ${units[i]}`;
}
